export const shotQualityRanges = (quality?: number) => {
    if (!quality && quality !== 0) {
        return {
            quality: "none",
            txtRange: ""
        }
    }
    if (quality <= 49) {
        return {
            quality: "poor",
            txtRange: "Needs Work!"
        }
    }
    if (50 <= quality && quality <= 79) {
        return {
            quality: "bellow_avg",
            txtRange: "Avg!"
        }
    }
    if (80 <= quality && quality <= 99) {
        return {
            quality: "good",
            txtRange: "Great!"
        }
    }
    if (100 <= quality && quality <= 120) {
        return {
            quality: "tour_level",
            txtRange: "Tour Level!"
        }
    }
    if (quality >= 121) {
        return {
            quality: "exceptional",
            txtRange: "Exceptional!"
        }
    }
    return {
        quality: "none",
        txtRange: ""
    }
}